// @flow

export const postInit = (data: ?FormData): * => {
  return { method: "POST", mode: "cors", credentials: "include", body: data };
};

export const graphQLInit = (data: string): * => {
  const formData = new FormData();
  formData.append("query", data);

  return {
    method: "POST",
    mode: "cors",
    credentials: "include",
    body: formData
  };
};

export const putInit = (form_data: ?FormData): * => ({
  method: "PUT",
  mode: "cors",
  credentials: "include",
  body: form_data
});

export const getInit = {
  method: "GET",
  mode: "cors",
  credentials: "include"
};

export const deleteInit = (form_data: ?FormData): * => ({
  method: "DELETE",
  mode: "cors",
  credentials: "include",
  body: form_data
});

export const postBody = (formData?: FormData): RequestInit => {
  return {
    method: "POST",
    mode: "cors",
    credentials: "include",
    body: JSON.stringify(formData),
    headers: {
      "Content-Type": "application/json"
    }
  };
};

export const putBody = (formData?: FormData): RequestInit => {
  return {
    method: "PUT",
    mode: "cors",
    credentials: "include",
    body: JSON.stringify(formData),
    headers: {
      "Content-Type": "application/json"
    }
  };
};
